import SectionContainer from "../../ui/SectionContainer";
import HighlightBand from "../../ui/HighlightBand";

import { Information } from "./styles";

import BackgroundImage from "../../../assets/images/sections/esp-experience/background.jpg";
import Illustration from "../../../assets/images/sections/esp-experience/illustration.png";
import ExperienceLogo from "../../../assets/images/sections/esp-experience/logo.svg";

const EspExperience = () => {
  return (
    <SectionContainer backgroundImage={BackgroundImage} id="esp">
      <Information>
        <img src={ExperienceLogo} alt="imagem" />
        <p>
          Muito mais que treino! <br /> A{" "}
          <HighlightBand>
            <span>ESP Experience</span>
          </HighlightBand>{" "}
          é um programa especial com atividades diferentes das rotinas
          convencionais, unindo treino técnico, tático e muita diversão.
        </p>
        <p>
          Acontece nos melhores hotéis, clubes e arenas do país e é aberto para
          alunos e não alunos.
        </p>
      </Information>

      <img src={Illustration} alt="imagem" />
    </SectionContainer>
  );
};

export default EspExperience;
